import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Input } from '../../components/ui/Input';
import { Button } from '../../components/ui/Button';
import { LockIcon, MailIcon } from 'lucide-react';
const AdminLogin = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [error, setError] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Mock authentication - in production, this would call an API
    if (formData.email === 'admin@certifieddevs.com' && formData.password === 'admin123') {
      // Store auth token in localStorage
      localStorage.setItem('adminAuth', 'true');
      navigate('/admin/dashboard');
    } else {
      setError('Invalid email or password');
    }
  };
  return <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8" data-id="element-317">
      <div className="max-w-md w-full" data-id="element-318">
        <div className="bg-white rounded-lg shadow-md p-8" data-id="element-319">
          <div className="text-center mb-8" data-id="element-320">
            <div className="flex justify-center mb-4" data-id="element-321">
              <div className="w-16 h-16 bg-[#FF3B30] rounded-full flex items-center justify-center" data-id="element-322">
                <LockIcon className="w-8 h-8 text-white" data-id="element-323" />
              </div>
            </div>
            <h2 className="text-3xl font-bold text-gray-900" data-id="element-324">Admin Login</h2>
            <p className="mt-2 text-sm text-gray-600" data-id="element-325">
              Sign in to access the admin dashboard
            </p>
          </div>
          {error && <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-md" data-id="element-326">
              <p className="text-sm text-red-600" data-id="element-327">{error}</p>
            </div>}
          <form onSubmit={handleSubmit} className="space-y-6" data-id="element-328">
            <div data-id="element-329">
              <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-330">
                Email Address
              </label>
              <div className="relative" data-id="element-331">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-332">
                  <MailIcon className="h-5 w-5 text-gray-400" data-id="element-333" />
                </div>
                <input id="email" type="email" required className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#FF3B30] focus:border-[#FF3B30]" placeholder="admin@certifieddevs.com" value={formData.email} onChange={e => setFormData({
                ...formData,
                email: e.target.value
              })} data-id="element-334" />
              </div>
            </div>
            <div data-id="element-335">
              <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-336">
                Password
              </label>
              <div className="relative" data-id="element-337">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-338">
                  <LockIcon className="h-5 w-5 text-gray-400" data-id="element-339" />
                </div>
                <input id="password" type="password" required className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#FF3B30] focus:border-[#FF3B30]" placeholder="••••••••" value={formData.password} onChange={e => setFormData({
                ...formData,
                password: e.target.value
              })} data-id="element-340" />
              </div>
            </div>
            <Button type="submit" variant="primary" fullWidth size="lg" data-id="element-341">
              Sign In
            </Button>
          </form>
          <div className="mt-6 text-center" data-id="element-342">
            <p className="text-xs text-gray-500" data-id="element-343">
              Demo credentials: admin@certifieddevs.com / admin123
            </p>
          </div>
        </div>
      </div>
    </div>;
};
export default AdminLogin;